import PageShell from "./PageShell";
import PillarSection from "@/components/site/PillarSection";
import SeasonalMenus from "@/components/site/SeasonalMenus";
import ThemedMenus from "@/components/site/ThemedMenus";
import { IMAGES } from "@/lib/content";

const GALLERY = [
  { src: IMAGES.chef, label: "Private Chefs" },
  { src: IMAGES.tableSacred, label: "The Table" },
  { src: IMAGES.foodWinter, label: "Fireside Dining" },
  { src: IMAGES.foodSummer, label: "Adventure Catering" },
];

export default function TablePage() {
  return (
    <PageShell testId="page-table">
      <PillarSection
        pillarKey="Table"
        heroImage={IMAGES.chef}
        galleryImages={GALLERY}
      >
        <SeasonalMenus />
        <ThemedMenus />
      </PillarSection>
    </PageShell>
  );
}
